import React from "react";
import InputMask from "react-input-mask";

const TelefoneInput = (props) => (
  <InputMask placeholder="Informe o Telefone" mask={'(99) 99999-9999'} className={props.className} value={props.value} onChange={props.onChange} disabled={props.disabled} />
);

export default TelefoneInput;